<template>
    <div class="pagination">
        <div class="pagination__left">
            <el-pagination
                class="pagination__item"
                layout="pager"
                ref="pagination"
                :total="paginate.total"
                :page-size="paginate.per_page"
                :current-page="paginate.current_page"
                @current-change="$emit('current-change', $event)">
            </el-pagination>
            <div class="pagination__jumper" v-if="paginate.last_page > 5">
                <el-input class="input input--small" :placeholder="32" v-model="jumper"></el-input>
                <button type="button" class="btn btn--small btn--secondary-bg" @click="clickOnJumper(jumper)">Ок</button>
            </div>
        </div>
        <div class="pagination__right">
            <button type="button" class="btn btn--circle btn--secondary-bg pagination__arrow" :disabled="paginate.current_page === 1" @click="$refs.pagination.prev()">
                <svg width="26" height="26">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-arrow_left"></use>
                </svg>
            </button>
            <button type="button" class="btn btn--circle btn--secondary-bg pagination__arrow" :disabled="paginate.current_page === paginate.last_page" @click="$refs.pagination.next()">
                <svg width="26" height="26">
                    <use xlink:href="/assets/front/img/sprite.svg#icon-arrow_right"></use>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "ArchivePagesPagination",
    props: {
        paginate: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        jumper: ''
    }),
    methods: {
        clickOnJumper(jumper) {
            if (jumper >= 1 && jumper <= this.paginate.last_page) {
                this.$emit('current-change', jumper);

            } else {
                this.$appNotify.error('Страница указана неверно');
            }

            this.jumper = null;
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";
.pagination {
    margin-top: 3.5rem;
    padding-top: 3.5rem;
    border-top: 1px solid #E9E9E9;
    padding-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow-x: auto;
    @media (max-width: 550px) {
        flex-direction: column;
    }
}

.pagination__jumper {
    display: grid;
    grid-template-columns: 130px 75px;
    grid-gap: 9px;

    @media (min-width: $screen-lg) {
        margin-left: 3rem;
    }

    @media (max-width: 1159px) {
        display: none;
    }
}

.pagination__left {
    margin-right: 20px;
    display: flex;
    align-items: center;
}

.pagination__right {
    @media (max-width: 550px) {
        margin-top: 2.9rem;
    }
}

.pagination__arrow:not(:last-child) {
    margin-right: 2rem;
}

.pagination__item {
    &::v-deep li {
        color: #353D51;
        font-size: 18px;
        font-weight: 500;
        letter-spacing: -1.25px;
        min-width: 40px;
        width: 40px;
        min-height: 40px;
        height: 40px;
        border-radius: 100%;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        border: 1px solid transparent;
    }

    &::v-deep li.btn-quicknext, &::v-deep li.btn-quickprev {
        line-height: 1;
    }

    &::v-deep li.active {
        border-color: rgba(53, 61, 81, 0.4);
    }
}

</style>
